<irembogov-item-selection-table
  [columns]="field.props['columns'] || []"
  [data]="items"
  [loading]="loading"
  [asyncData]="!!field.props['dataset']"
  [searchable]="field.props['searchable'] !== false"
  [emptyMessage]="field.props['emptyMessage'] || 'No items available'"
  [searchPlaceHolder]="field.props['searchPlaceHolder'] || 'Search'"
  [customTableClass]="field.props['customTableClass']"
  [title]="field.props['title']"
  [pageSize]="pagination.size"
  [currentPage]="pagination.page"
  [collectionSize]="pagination.collectionSize"
  [selectionConfig]="field.props['selectionConfig']"
  [targetItems]="targetItems"
  (itemAdded)="handleItemAdded($event)"
  (itemRemoved)="handleItemRemoved($event)"
  (validationError)="handleValidationError($event)"
  (searchChanged)="handleSearch($event)"
  (pageChanged)="handlePagination($event)">
</irembogov-item-selection-table>
